import { useGetDriveItemThumbnailsQuery } from "../../redux/slices/graphApiSlice";
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  CircularProgress,
  Divider,
  Icon,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { Done, ErrorOutline, OpenInNew } from "@mui/icons-material";
import { IDriveItem } from "../../types/driveItem";
import { useGetContractQuery } from "../../redux/slices/indexApiSlice";
import { useTranslation } from "react-i18next";
import { AIReadingStatus } from "../../types/contract";
import { skipToken } from "@reduxjs/toolkit/dist/query";

type DriveItemCardProps = {
  driveItem: IDriveItem;
};

const DriveItemCard = (props: DriveItemCardProps) => {
  const { t } = useTranslation();

  const driveItem = props.driveItem;

  const { data: thumbnails, isLoading: loadingThumbnails } =
    useGetDriveItemThumbnailsQuery({
      driveId: driveItem?.parentReference.driveId,
      driveItemId: driveItem.id,
    });

  const { data: contract } = useGetContractQuery(driveItem?.id ?? skipToken);

  return (
    <Card variant="outlined">
      <CardActionArea href={`${driveItem.webUrl}?web=1`} target="_blank">
        {!loadingThumbnails &&
          thumbnails?.value &&
          thumbnails?.value.length > 0 && (
            <CardMedia
              sx={{
                height: thumbnails.value[0].medium?.height,
                width: thumbnails.value[0].medium?.width,
                margin: "0 auto",
                marginTop: 3,
              }}
              image={thumbnails.value[0].medium?.url}
              title={driveItem.name}
            />
          )}
        <CardContent>
          <Tooltip title={driveItem.name} arrow placement="top">
            <Typography
              variant="subtitle2"
              gutterBottom
              sx={{
                display: "-webkit-box",
                "-webkit-box-orient": "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                lineHeight: "1.2em",
                height: "2.4em",
                textAlign: "center",
              }}
            >
              {driveItem.name}
            </Typography>
          </Tooltip>
        </CardContent>
      </CardActionArea>

      <CardActions disableSpacing sx={{ justifyContent: "space-between" }}>
        <Stack direction="column" gap={3} width="100%" justifyContent="start">
          <Divider />

          <Stack direction="row" justifyContent="space-between">
            {driveItem.id && (
              <Icon>
                {contract?.analyzeStatus === AIReadingStatus.COMPLETED ? (
                  <Done color="success" />
                ) : contract?.analyzeStatus === AIReadingStatus.ANALYZING ? (
                  <CircularProgress size={16} />
                ) : contract?.analyzeStatus === AIReadingStatus.ERROR ? (
                  <ErrorOutline color="error" />
                ) : (
                  <Typography variant="caption">
                    {contract?.analyzeStatus}
                  </Typography>
                )}
              </Icon>
            )}

            {contract?.id ? (
              <Button
                variant="contained"
                // size="small"
                color="primary"
                href={`/contract/${contract?.id}`}
                target="_blank"
              >
                {t("View contract")}
              </Button>
            ) : (
              <Button disabled>{t("Not synced")}</Button>
            )}

            <Tooltip title={t("View in SharePoint")!}>
              <IconButton
                size="small"
                color="primary"
                href={`${driveItem.webUrl}?web=1`}
                target="_blank"
                // onClick={() => {}}
              >
                <OpenInNew />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      </CardActions>
    </Card>
  );
};
export default DriveItemCard;
